var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"modal-header\"><button type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"$close()\" class=\"close\">&times;</button><h4 class=\"modal-title\">Forget this card</h4></div><div class=\"modal-body\">Are you sure you want to forget this card?</div><div class=\"modal-footer\"><button type=\"button\" data-dismiss=\"modal\" ng-click=\"$close()\" class=\"btn btn-default\">No, Cancel That Request</button><button ng-click=\"forgetCard()\" ng-disabled=\"processing\" class=\"btn btn-danger btn-ok\">Yes, Forget this card</button></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/view/ForgetCardPopup.jade
// module id = 828
// module chunks = 0